import { render, staticRenderFns } from "./client.vue?vue&type=template&id=51741a2a&scoped=true&"
import script from "./client.js?vue&type=script&lang=js&"
export * from "./client.js?vue&type=script&lang=js&"
import style0 from "./client.scss?vue&type=style&index=0&id=51741a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51741a2a",
  null
  
)

export default component.exports